import Shift from "../../utils/shiftFunctions";
import { getHeaders, URI_API } from "../../utils/config";
import { useEffect, useState } from "react";

export interface AssignedFunction {
	id: string;
	nurseId: string;
	nurseName: string;
	date: string;
	schedule: string;
	classx: string;
}

export interface Function {
	id: string;
	description: string;
	value: number;
}

export function useAssignFunctionModal() {
	const [assignedFunctions, setAssignedFunctions] = useState<AssignedFunction[]>([]);
	const [functions, setFunctions] = useState<Function[]>([]);

	const [selectedNurse, setSelectedNurse] = useState<string>("");
	const [selectedFunction, setSelectedFunction] = useState<string>("");

	const [isLoading, setIsLoading] = useState<boolean>(false);

	const onClean = () => {
		setSelectedFunction("");
		setSelectedNurse("");
	};

	const canSave = (): boolean => selectedNurse !== "" && selectedFunction !== "";

	const getNursesByDay = async (shift: any, shiftCount: any): Promise<void> => {
		if (!shift?.key) return;

		const currentDate = new Date();

		const hours = currentDate.getHours();

		const dateString = new Date(
			currentDate.getFullYear() +
				"-" +
				(currentDate.getMonth() + 1) +
				"-" +
				currentDate.getDate(),
		);

		let parsedString = "";
		if (hours >= 0 && hours < 7 && shift.key === "nocturno") {
			const day = 1000 * 60 * 60 * 24;
			const yesterday = new Date(dateString.getTime() - day);
			parsedString = yesterday.getFullYear() + "-" +
              String(yesterday.getMonth() + 1).padStart(2, "0") + "-" +
              String(yesterday.getDate()).padStart(2, "0");
		} else {
			parsedString = dateString.getFullYear() + "-" +
              String(dateString.getMonth() + 1).padStart(2, "0") + "-" +
              String(dateString.getDate()).padStart(2, "0");
		}

		fetch(`${URI_API}/nursing_calendarRea/${parsedString}/${shift.key}`, getHeaders())
			.then((res) => res.json())
			.then((body) => {
				const newAssignedFunctions: AssignedFunction[] = [];

				Object.entries(body).forEach(([_, details]) => {
					const { id, nurse_id, nursename, schedule, date, classx } = details as {
						id: string;
						nurse_id: string;
						nursename: string;
						schedule: string;
						date: string;
						classx: string;
					};

					const newAssignedFunction: AssignedFunction = {
						id,
						nurseId: nurse_id,
						nurseName: nursename,
						schedule,
						date,
						classx,
					};

					newAssignedFunctions.push(newAssignedFunction);
				});

				setAssignedFunctions(newAssignedFunctions);
			});
	};

	const getFunctions = async (): Promise<void> => {
		fetch(`${URI_API}/functions`, getHeaders())
			.then((res) => res.json())
			.then((body) => {
				const newFunctions: Function[] = [];

				Object.entries(body).forEach(([_, details]) => {
					const { id, description, value } = details as {
						id: string;
						description: string;
						value: number;
					};

					const newFunction: Function = {
						id,
						description,
						value,
					};
					newFunctions.push(newFunction);
				});

				setFunctions(newFunctions);
			});
	};

	useEffect(() => {
		Promise.all([
			fetch(`${URI_API}/current_work_schedule_name`, getHeaders())
				.then((res) => res.json())
				.then((body) => {
					let currentShift = Shift.Current(body);
					let shift: Shift | null = Shift.AsOption(currentShift);
					getNursesByDay(shift, body);
				}),

			getFunctions(),
		]);
	}, []);

	const onSave = async (): Promise<void> => {
		setIsLoading(true);
		const today = new Date();
		const date = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
		const data = {
			function_id: selectedFunction,
			nurse_id: selectedNurse,
			date: date,
			is_active: "TRUE",
		};

		await fetch(`${URI_API}/assigned_functions`, getHeaders("POST", data))
			.then((res) => res.json())
			.then((_) => onClean())
			.then(() => setIsLoading(false));
	};

	return {
		assignedFunctions,
		functions,
		selectedNurse,
		selectedFunction,
		isLoading,
		setSelectedNurse,
		setSelectedFunction,
		canSave,
		onSave,
		onClean,
	};
}
